import { render, staticRenderFns } from "./NewRoleDialog.vue?vue&type=template&id=0f26af9d"
import script from "./NewRoleDialog.vue?vue&type=script&lang=js"
export * from "./NewRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports